module.exports = __webpack_public_path__ + "img/brightness-low-fill.3c26d626.svg";